export default __webpack_public_path__ + "static/media/create_account.116c40c2.svg";